<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2">
    <div class="calls row">
      <div class="col-12">
        <h2 cy="page-title" class="font-weight-bolder mb-2 full-width">Print Approved Calls</h2>
        <router-link :to="{ name: 'calls' }" class="d-inline-block mb-2">
          &laquo; Back to calls
        </router-link>

        <section v-if="!loading">
          <section v-if="prison" class="row align-items-end">
            <section class="col-sm-3">
              <label>Please enter a date for calls to print</label>
              <b-form-datepicker v-model="date" @input="getVisits()"
                                 today-button cy="date"
                                 reset-button
                                 close-button
                                 :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              ></b-form-datepicker>
            </section>
            <div class="col-sm-3" v-if="date">
              <b-btn @click="getVisits()" variant="primary" class="sm-full-width my-sm-0 mb-1 mt-1"><i class="fa fa-sync" style="margin-right: 5px"></i> Refresh Calls</b-btn>
            </div>
            <div class="col-sm-3">
              <b-btn @click="print()" v-if="date" :class="{'disabled': calls.length === 0}" variant="success" class="sm-full-width my-sm-0 mb-1">
                <span class="fa fa-print" style="margin-right: 5px"></span> Print Calls
              </b-btn>
            </div>

            <div class="col-12" v-if="date">
              <print-list :calls="filteredVisits(calls)"></print-list>
            </div>
          </section>
          <section v-else>
            <p>There was a problem getting your call data, please refresh and try again</p>
          </section>
        </section>

        <b-spinner v-else variant="primary" label="Loading call"></b-spinner>
      </div>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  import VisitService from '@/services/VisitService';
  import moment from 'moment';
  import { getVisitBookedForDate } from '@/util/helpers';
  import PrintList from '@/views/calls/printCalls/PrintList.vue';

  export default {
    name: 'PrintCalls',
    components: {
      PrintList,
    },
    props: {},
    data() {
      return {
        loading: true,
        date: '',
        calls: [],
      };
    },
    computed: {
      ...mapState({
        user: state => state.auth.user,
        prison: state => state.prison.prison,
      }),
    },
    mounted() {
      this.setPrisonData();
    },
    methods: {
      async setPrisonData() {
        const Prison = await this.$store.dispatch('prison/getPrison');

        if (Prison && this.prison.enable_wings) {
          //
        }

        // Finished loading
        this.loading = false;
      },
      getVisits() {
        VisitService.getApprovedVisits().then(res => {
          this.calls = this.orderVisits(res.data).map(call => {
            const bookedFor = getVisitBookedForDate(call);
            return {
              bookedFor: bookedFor.bookedFor,
              bookedForDate: bookedFor.bookedForDate,
              ...call,
            };
          });
          this.loading = false;
        }).catch(() => {
          this.$toast.error('Could not get calls, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      orderVisits(visits) {
        if (!!visits && visits.length > 0) {
          return visits.sort((v1, v2) => {
            let v1Slot = v1.requested_booking_slot_1;
            let v2Slot = v2.requested_booking_slot_1;
            if (v1.booked_slot) {
              v1Slot = v1.booked_slot;
            }
            if (v2.booked_slot) {
              v2Slot = v2.booked_slot;
            }
            const v1StartDate = new Date(v1Slot.start_date_time);
            const v2StartDate = new Date(v2Slot.start_date_time);
            // Compare dates
            return v1StartDate.getTime() - v2StartDate.getTime();
          });
        }
        return [];
      },
      filteredVisits() {
        let filteredVisits = [...this.calls];
        if (this.date) {
          const beforeDate = moment(this.date).format();
          filteredVisits = filteredVisits.filter(visit => moment(visit.bookedForDate).isSame(beforeDate, 'day'));
        }
        return filteredVisits;
      },
      print() {
        this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true);
        setTimeout(() => {
          window.print();
        }, 500);
      },
    },
  };
</script>
